import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from 'moment';
import Select from '../Select';
import { hasClass, addClass, removeClass, isMobile } from '../../common/util';
import Icon from "../../icons";

function MyCalendar(props) {
    const monthFormat = "MMMM";
    const yearFormat = "YYYY";
    const hourFormat = "hh A";
    
    const [currentDate, setCurrentDate] = useState(props.selectedDate ? props.selectedDate : moment())
    const [selectedDate, setSelectedDate] = useState(props.selectedDate ? props.selectedDate : moment())
    const { diaries } = useSelector(state => ({
        diaries: state.diaryCreation.diariesByDate,
    }), shallowEqual);

    const dispatch = useDispatch();

    useEffect(() => {
        const dateFormat = 'MM/DD/YYYY'
        let startDate = moment(currentDate).startOf('week').format(dateFormat);
        let endDate = moment(currentDate).endOf('week').format(dateFormat);

        // dispatch(fetchDiariesByDate({
        //     startdate: startDate,
        //     endDate: endDate,
        //     _: + new Date
        // }))

    }, [currentDate]);

    const nextWeek = () => {
        setCurrentDate(moment(currentDate).add(1, "week"))
        setSelectedDate(moment(selectedDate).add(1, "week"))
    }

    const prevWeek = () => {
        setCurrentDate(moment(currentDate).subtract(1, "week"))
        setSelectedDate(moment(selectedDate).subtract(1, "week"))
    }

    const onDateClick = (day) => {
        setSelectedDate(day)
    }

    const week = () => {
        let startDate = moment(currentDate).startOf('week');
        const monthStart = moment(currentDate).startOf('month');
        const monthEnd = moment(monthStart).endOf('month');
        // const endDate = moment(monthEnd).endOf('week'); 
        const dateFormat = "D";
        let formattedDate = "";
        let days = [];
        let day = startDate;

        for (let i = 0; i < 7; i++) {
            formattedDate = moment(day).format(dateFormat)
            const cloneDay = day;
            days.push(
                <li key={formattedDate}
                    className={`column cell ${moment(day).isSame(selectedDate, 'day')
                            ? "select" : moment(day).isSame(moment(), 'day') ? "active" : ""}`}
                    key={day}
                    onClick={() => onDateClick(cloneDay)}
                >
                    {moment(day).format("ddd")}
                    <a className={diaries.some(data => data.Key.Day == formattedDate) ? "eventHere" : ""}>{formattedDate}</a>
                </li>
            );
            day = moment(day).add(1, 'days');
        }

        return (
            <div className="calDateSelector">
                <div className="iconLeft" onClick={prevWeek}></div>
                    <ul>
                        {days}
                    </ul>
                <div className="iconRight" onClick={nextWeek}></div>
            </div>
        )
    }

    const onChangeMonth = (month) => {
        setCurrentDate(moment(currentDate).month(month))
        setSelectedDate(moment(selectedDate).month(month))
    }

    const onChangeYear = (year) => {
        setCurrentDate(moment(currentDate).year(year))
        setSelectedDate(moment(selectedDate).year(year))
    }

    const onClickToday = () => {
        setSelectedDate(moment())
        setCurrentDate(moment())
    }

    const header = () => {
        const months = moment.months()
        const years = []
        for (let i = 1990; i < 2100; i++) {
            years.push({ label: i, value: i })
        }
        return (
            <header className="calHeader colFlex">
                <span className="rowSpaceBetween">
                <h2 className="mb__12">Check Availability</h2>
                { isMobile() && 
                <a className="close"  onClick = {props.hideCalendar}>
                    <Icon name="close" className="icon ml"  />
                </a> }
                </span>
                <div className="rowFlex mb__12 alignMiddle">
                    <div className="rowFlex">
                    <Select
                        options={months.map(month => (
                            { label: month, value: month }
                        ))}
                        selected={moment(currentDate).format(monthFormat)}
                        onSelect={onChangeMonth}
                        openOnClick={true}
                        iconName="downArrow"
                        styleClass="mr"
                    />
                    <Select
                        options={years}
                        selected={moment(currentDate).format(yearFormat)}
                        onSelect={onChangeYear}
                        openOnClick={true}
                        styleClass="mr"
                        iconName="downArrow"
                    />
                </div>
                    {!moment().isSame(selectedDate, 'day') &&
                        <a className="ttController" onClick={onClickToday}>Today</a>
                    }
                </div>
            </header>
        )
    }

    const hoursOfDay = () => {
        let startTime = moment(selectedDate).startOf('day');
        let hours = [];
        for (let i = 0; i < 24; i++) {
            const h = moment(startTime).add(i, "hours")
            const formattedHour = h.format(hourFormat)
            const diariesToRender = diaries.filter(diary => diary.Key.Day == moment(selectedDate).format("D") && diary.Key.Time == formattedHour)
            hours.push(
                <li className="quickTooltip-top" data-quicktooltip="Add due date" key={formattedHour} onClick={() => props.onTimeSelect(h)}>
                    <div className="time">{formattedHour}</div>
                    <div className="eventPlace">
                        {diariesToRender.length > 0 && (
                            <ul className="colFlex">
                                {diariesToRender.map((diary, i) => (
                                    <li key={i}>
                                        <div className="eventCreated">
                                            {diary.TodoData.Title}
                                    </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </li>
            );
        }
        return (
            <div className="calViewBy Days">
                <ul className="colFlex scrollArea" onScroll={handleScroll}>
                    {hours}
                </ul>
            </div>
        )
    }

    const handleScroll = (e) => {
        const scrollPos = document.querySelector(".calViewBy .colFlex.scrollArea").scrollTop
        const dateDiv = document.querySelector(".calDateSelector")
        if(scrollPos !== 0) {
            if(!hasClass(dateDiv, "shadow")){
                addClass(dateDiv, "shadow")
            }
        } else {
            if(hasClass(dateDiv, "shadow")){
                removeClass(dateDiv, "shadow")
            }
        }
    }

    return (
        <div className="ccCalendar">
            {header()}
            {week()}
            {hoursOfDay()}
        </div>
    );
}

export default MyCalendar;
